import { render, staticRenderFns } from "./UnitModal.vue?vue&type=template&id=bee03f54&"
import script from "./UnitModal.vue?vue&type=script&lang=js&"
export * from "./UnitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bee03f54')) {
      api.createRecord('bee03f54', component.options)
    } else {
      api.reload('bee03f54', component.options)
    }
    module.hot.accept("./UnitModal.vue?vue&type=template&id=bee03f54&", function () {
      api.rerender('bee03f54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/modals/UnitModal.vue"
export default component.exports